import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckboxDropdownMenu from '@/shared/components/input/CheckboxDropdownMenu';
import { Dropdown } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';
import { defineMessages, useIntl } from 'react-intl';
const messages = defineMessages({
    SelectYourFilters: {
        id: 'SelectYourFilters',
        defaultMessage: 'Select your filters',
    },
    MoreFilters: {
        id: 'MoreFilters',
        defaultMessage: 'More filters',
    },
});
export const DynamicFilterDropdown = ({ items, onChange, }) => {
    const { formatMessage } = useIntl();
    if (!items || items.length <= 0)
        return null;
    return (_jsxs(Dropdown, Object.assign({ id: "dynamicFilterMenu" }, { children: [_jsxs(Dropdown.Toggle, Object.assign({ title: formatMessage(messages.SelectYourFilters) }, { children: [_jsx(FaFilter, { className: "react-icon margin5R" }), formatMessage(messages.MoreFilters)] })), _jsx(CheckboxDropdownMenu, { bsRole: "menu", items: items, onItemChanged: onChange })] })));
};
export default DynamicFilterDropdown;
